/**
 * User privilege table column configuration
 */

import { ColumnConfig } from '../hooks/useTablePreferences';

export const privilegeColumns: ColumnConfig[] = [
  {
    key: 'name',
    label: 'Name',
    defaultWidth: 180,
    minWidth: 150,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'manageUsers',
    label: 'Manage Users',
    defaultWidth: 120,
    minWidth: 100,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'allPatients',
    label: 'All Patients',
    defaultWidth: 120,
    minWidth: 100,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'questionnaires',
    label: 'Questionnaires',
    defaultWidth: 130,
    minWidth: 110,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'emailSmsTemplates',
    label: 'Email & SMS Templates',
    defaultWidth: 170,
    minWidth: 150,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'config',
    label: 'Config',
    defaultWidth: 100,
    minWidth: 80,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'configSync',
    label: 'Config Sync',
    defaultWidth: 110,
    minWidth: 90,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'fileTypes',
    label: 'File Types',
    defaultWidth: 110,
    minWidth: 90,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'taskTypes',
    label: 'Task Types',
    defaultWidth: 110,
    minWidth: 90,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'wellness',
    label: 'Wellness',
    defaultWidth: 100,
    minWidth: 80,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'promptDevelopment',
    label: 'Prompt Dev',
    defaultWidth: 110,
    minWidth: 90,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'docAssistant',
    label: 'Doc Assistant',
    defaultWidth: 120,
    minWidth: 100,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'clinicLogin',
    label: 'Clinic Login',
    defaultWidth: 120,
    minWidth: 100,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'hmo',
    label: 'HMO',
    defaultWidth: 100,
    minWidth: 80,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'referral',
    label: 'Referral',
    defaultWidth: 100,
    minWidth: 80,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'leads',
    label: 'Leads',
    defaultWidth: 100,
    minWidth: 80,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'view_video_rooms',
    label: 'Video Rooms',
    defaultWidth: 120,
    minWidth: 80,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'createdAt',
    label: 'Created',
    defaultWidth: 120,
    minWidth: 100,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
];
